// This file contains event listener utilities for the timeout component.
// This is in the component folder instead of util because it's specific
// only this component.

const eventTypes = [
  'keypress',
  'mousemove',
  'mousedown',
  'scroll',
  'touchmove',
  'pointermove'
]
export const addEventListeners = (listener: () => void) => {
  eventTypes.forEach((type) => {
    window.addEventListener(type, listener, false)
  })
}
export const removeEventListeners = (listener: (() => void) | null) => {
  if (listener) {
    eventTypes.forEach((type) => {
      window.removeEventListener(type, listener, false)
    })
  }
}

// First at 12 minute mark
export const getTimeoutOpenWarningPeriod = () => {
  let timeoutPeriod = NaN
  if (process.env.REACT_APP_TIMEOUT_OPEN_WARNING_PERIOD) {
    timeoutPeriod = parseInt(process.env.REACT_APP_TIMEOUT_OPEN_WARNING_PERIOD)
  }

  return timeoutPeriod || 720000 // 12 minutes
}

// Second at 3 minute mark
export const getTimeoutWarningDisplayPeriod = () => {
  let timeoutPeriod2 = NaN
  if (process.env.REACT_APP_TIMEOUT_WARNING_DISPLAY_PERIOD) {
    timeoutPeriod2 = parseInt(process.env.REACT_APP_TIMEOUT_WARNING_DISPLAY_PERIOD)
  }

  return timeoutPeriod2 || 180000 // 3 minutes
}
